import { useCallback, useMemo, useState } from "react";
import { useToast } from "../../../Hooks/ToasContext";
import { ListProductsServiceUseCase } from "../../../Usecase/ProductsService/list-products-service-usecase";
import { IProductServiceEntity } from "../../../Services/api/products-services/products-services-interface";
import { IListSearchPayload } from "../../../Components/List/list.types";

interface IUseServicesListProps {
  ListProductsServiceUseCase: ListProductsServiceUseCase
}

export function useServicesList({ ListProductsServiceUseCase }: IUseServicesListProps){
    const [loading, setLoading] = useState(true)
    const [loadError, setLoadError] = useState(false)
    const [page, setPage] = useState(1)
    const [data, setData] = useState<IProductServiceEntity[]>([])
    const [totalRegisters, setTotalRegisters] = useState(0)
    const [boxToDestroy, setBoxToDestroy] = useState('')

    const { showToast } = useToast()

    const listServices = useCallback(async (currentPage: number) => {
        try {
          setLoading(true)
          setLoadError(false)

          const listResult = await ListProductsServiceUseCase.handle(currentPage);

          if (listResult.isFailure) {
            setLoadError(true)
            showToast(String(listResult?.error?.error), 'error');
            return;
          }

         const list = listResult.getValue()

         if(list){
            setData(list.data)
            setTotalRegisters(list.total)
            setLoadError(false)
         }

         setPage(currentPage)
        } catch (error) {
          setLoadError(true)
          console.error("error listServices function: ", error)
        } finally {
          setLoading(false);
        }
      }, [ListProductsServiceUseCase, showToast]);

    const handlePageChange = useCallback(({ page: nextPage }: IListSearchPayload) => {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      listServices(nextPage)
    }, [listServices]);

    const list = useMemo(() => {
        return data?.map(product => ({ ...product })) ?? []
    }, [data])

    return {
        loading,
        loadError,
        listServices,
        list,
        data,
        setBoxToDestroy,
        boxToDestroy,
        totalRegisters,
        page,
        handlePageChange,
    }
}
